import { Injectable } from '@angular/core';
import { SignatureV4, Headers } from 'signature-v4';
//@ts-ignore
import { environment } from '../../../environments/environment';

@Injectable()
export class AwsSignerService {
    private apiKey: string;

    constructor() {
        this.apiKey = environment.cesAPI.apiKey;
    }

    getAwsHeader(url: string, method: string, body?: any) {
        if (!method) {
            method = 'GET';
        }
        const requestOptions = {
            url,
            method,
            payload: '',
            headers: new Headers({ 'Content-Type': 'application/json' })
        };

        if (body) {
            requestOptions.payload = JSON.stringify(body);
        }

        //@ts-ignore
        const signer = new SignatureV4(requestOptions, 'execute-api', localStorage.getItem('region-id'));

        const accessKeyId = sessionStorage.getItem('accessKeyId');
        const secretAccessKey = sessionStorage.getItem('secretAccessKey');
        const sessionToken = sessionStorage.getItem('sessionToken');

        if (!accessKeyId || !secretAccessKey || !sessionToken) {
            console.error('Missing accessKeyId, secretAccessKey, or sessionToken');
            return {};
        }

        const awsHeaders = signer.createHeaders(accessKeyId, secretAccessKey, sessionToken);

        return {
            'x-api-key': this.apiKey,
            'X-Amz-Date': awsHeaders.get('X-Amz-Date'),
            'Authorization': awsHeaders.get('Authorization'),
            'x-amz-security-token': awsHeaders.get('x-amz-security-token')
        };
    }
}
